export const development = {
  site: {
    baseName: ''
  },
  stripe: {
    key: 'pk_test_XjwossyzeR1943y1OYY3hER1'
  },
  api: {
    url: '/api/v1/user',
    baseUrl: 'http://localhost:4001',
    baseUrlDownload: 'http://localhost:4000'
  }
};

export default development;
